// extracted by mini-css-extract-plugin
export default {"add-button":"styles_add-button__nFJCS"};